<div class="media-library-modal">
  <div class="title">
    {{ "campaign.widget.mediaLibrary.title" | translate }}
    <button mat-icon-button class="close-button" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="content">
    <app-media-library [defaultCategory]="defaultCategory" (close)="mediaSelected($event)" [data]="data" [selectingMedia]="true"></app-media-library>
  </div>
</div>
